<template>
  <div ref="canvas_side" class="canvas_side">
    <canvas
      :id="id"
      @touchstart="onCanvasMouseDown"
      @touchend="onCanvasMouseUp"
      @touchmove="onCanvasMouseMove"
      @mouseout="onCanvasMouseOut"
      ref="canvas"
      @touchmove.prevent
    ></canvas>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'cv',
  data () {
    return {
      pjImg: null,
      canvas: null,
      context: null,
      proportion: 1,
      cvX: 0,
      cvY: 0,

      selectedRect: null,
      isDragging: false,
      isMouseInCanvas: false
    }
  },
  props: [
    'id',
    'w',
    'h',
    'pjRect',
    'roomRect',
    'arrDashLines',
    'arrDashRemainLines',
    'arrOffsetLines',
    'arrRectLines',
    'arrLightingArea',
    'avlRect',
    'arrHelpLines',
    'arrHelpText',
    'arrCatchArea',
    'arrBlackArea',
    'arrRectHorSecLines',
    'arrowRects'
  ],
  computed: {
    ...mapState([
      'pjImgType',
      'graph',
      'houseInfo',
      'projectorChecked',
      'throwDistanceChecked',
      'screenSizeChecked',
      'drawData',
      'centerPositionInit',
      'vLensShiftNow',
      'hLensShiftNow',
      'initScreenSize',
      'projector_checked_side',
      'projector_checked_top',
      'flToB',
      'flToL',
      'offset',
      'selectedModelData',
      'vAngle',
      'hAngle',
      'isInFrontView',
      'selectedLensData',
      'screenMoveChecked',
      'position',
      'limitData',
      'aspectRatio',
      'isOutOfSpec',
      'realThrowDistanceChecked',
      'floorFootProjectorChecked'
    ]),
    floor_footProjector_checked: {
      get () {
        return this.floorFootProjectorChecked
      }
    },
    pjRectOnCanvas: {
      get () {
        return this.pjRectToCanvas()
      }
    },
    roomRectOnCanvas: {
      get () {
        return this.roomRectToCanvas()
      }
    },
    avlRectOnCanvas: {
      get () {
        return this.avlRectToCanvas()
      }
    },
    arrRectLinesOnCanvas: {
      get () {
        return this.arrRectLinesToCanvas()
      }
    },
    arrCatchAreaOnCanvas: {
      get () {
        return this.arrCatchAreaToCanvas()
      }
    },
    arrLightingAreaOnCanvas: {
      get () {
        return this.arrLightingAreaToCanvas()
      }
    },
    arrBlackAreaOnCanvas: {
      // eslint-disable-next-line vue/return-in-computed-property
      get () {
        if (this.arrBlackArea) {
          return this.arrBlackAreaToCanvas()
        }
      }
    },
    arrDashLinesOnCanvas: {
      get () {
        return this.arrDashLinesToCanvas()
      }
    },
    arrDashRemainLinesOnCanvas: {
      get () {
        return this.arrDashRemainLinesToCanvas()
      }
    },
    arrOffsetLinesOnCanvas: {
      get () {
        return this.arrOffsetLinesToCanvas()
      }
    },
    arrHelpLinesOnCanvas: {
      get () {
        return this.arrHelpLinesToCanvas()
      }
    },
    arrHelpTextOnCanvas: {
      get () {
        return this.arrHelpTextToCanvas()
      }
    },
    arrRectHorSecLinesOnCanvas: {
      get () {
        return this.arrRectHorSecLinesToCanvas()
      }
    },
    arrowRectsOnCanvas: {
      get () {
        return this.arrowRectsToCanvas()
      }
    }
  },
  watch: {
    pjImgType: function () {
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, this.selectedLensData)
    },
    position (newValue, oldValue) {
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, this.selectedLensData)
    },
    selectedLensData (newValue, oldValue) {
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, newValue)
    }
  },
  created () {
    this.pjImg = new Image()
  },
  mounted () {
    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')

    this.initPjImg()
    this.$nextTick(function () {
      this.resizeDraw()
    })
  },
  methods: {
    ...mapMutations([
      'PJX',
      'PJY',
      'PJZ',
      'SCRNW',
      'SCRNH',
      'SCREENSIZE',
      'SET_HLENSSHIFT',
      'SET_VLENSSHIFT',
      'VLENSSHIFT',
      'SET_TEMVLENSSHIFT',
      'SET_GRAPH_ROOMD'
    ]),
    initCanvasWH () {
      let offsetW = this.$refs.canvas_side.offsetWidth
      let offsetH = this.$refs.canvas_side.offsetHeight
      this.canvas.width = offsetW
      this.canvas.height = offsetH
    },
    getProportion () {
      const wRatio = this.w / this.$refs.canvas.width
      const hRatio = this.h / this.$refs.canvas.height
      let maxSize = parseFloat(this.$refs.canvas.height)
      let xFactor = 0.65
      if (wRatio >= hRatio) {
        maxSize = parseFloat(this.$refs.canvas.width)
      }
      maxSize = Number(maxSize) * xFactor
      if (wRatio >= hRatio) {
        this.proportion = this.w * 1 / maxSize
      } else {
        this.proportion = this.h * 1 / maxSize
      }
    },
    initCanvasXY () {
      this.cvX =
        (this.canvas.width - this.realToCanvas(this.w)) / 2
      this.cvY = (this.canvas.height - this.realToCanvas(this.h)) / 2
      this.context.translate(this.cvX, this.cvY)
    },
    clearCanvas () {
      this.context.clearRect(
        -this.cvX,
        -this.cvY,
        this.canvas.width,
        this.canvas.height
      )
    },
    refreshCv () {
      this.initCanvasWH()
      this.getProportion()
      this.initCanvasXY()
    },
    drawCv () {
      this.clearCanvas()
      this.$emit('setArrHelpLine', this.proportion)
      this.drawRoomRect()
      this.drawAvlRect()
      this.drawBlackArea()

      this.drawLightingArea()
      this.drawCatchArea()
      this.drawRectLines()
      this.drawPj()
      this.drawDashLines()
      this.drawDashRemainLines()
      this.drawOffsetLines()
      this.drawHelpLines()
      this.drawHelpText()
      this.drawRectHorSecLinesOnCanvas()
      this.drawArrowRects()
    },
    /**
     * 鼠标点击
     */
    onCanvasMouseDown (e) {
      if (this.id === 'sideView') {
        if (!this.projector_checked_side) {
          return
        }
      } else if (this.id === 'topView') {
        if (!this.projector_checked_top) {
          return
        }
      }
      var ev = e || window.event
      var touch = ev.targetTouches[0]
      var clickX = touch.clientX - this.cvX - touch.target.getBoundingClientRect().left
      var clickY = touch.clientY - this.cvY - touch.target.getBoundingClientRect().top
      // let offsetX = e.offsetX || (e.clientX - e.target.getBoundingClientRect().left)
      // let offsetY = e.offsetY || (e.clientY - e.target.getBoundingClientRect().top)
      // var clickX = offsetX - this.cvX
      // var clickY = offsetY - this.cvY
      //  查找被单击的矩形框
      var rect = this.pjRectOnCanvas

      this.isMouseInCanvas = true

      if (this.id === 'frontView' && this.screenMoveChecked) {
        // 当选中拖动的是屏幕时，拖动frontView
        let maxX = this.drawData[1][0].x
        let minX = this.drawData[1][0].x
        let maxZ = this.drawData[1][0].z
        let minZ = this.drawData[1][0].z
        for (let i = 1; i < this.drawData.length; i++) {
          for (let j = 0; j < this.drawData[i].length; j++) {
            if (this.drawData[i][j].x > maxX) {
              maxX = this.drawData[i][j].x
            }
            if (this.drawData[i][j].x < minX) {
              minX = this.drawData[i][j].x
            }
            if (this.drawData[i][j].z > maxZ) {
              maxZ = this.drawData[i][j].z
            }
            if (this.drawData[i][j].z < minZ) {
              minZ = this.drawData[i][j].z
            }
          }
        }
        if (clickX >= this.realToCanvas(minX) && clickX < this.realToCanvas(maxX) && clickY >= this.realToCanvas(minZ) && clickY < this.realToCanvas(maxZ)) {
          this.x1 = clickX - this.realToCanvas(minX)
          this.y1 = clickY - this.realToCanvas(minZ)
          rect.x = this.realToCanvas(minX)
          rect.y = this.realToCanvas(minZ)
          rect.width = this.realToCanvas(maxX - minX)
          rect.height = this.realToCanvas(maxZ - minZ)
          this.selectedRect = rect
          //  使圆圈允许拖拽
          this.isDragging = true
        }
      } else {
        this.widthstart = rect.x
        this.widthend = rect.x + rect.width

        this.heightstart = rect.y
        this.heightend = rect.y + rect.height

        //  判断这个点是否在矩形框中
        if (clickX >= this.widthstart && clickX < this.widthend && clickY >= this.heightstart && clickY < this.heightend) {
          //  清除之前选择的矩形框
          this.selectedRect = rect
          this.x1 = clickX - this.selectedRect.x
          this.y1 = clickY - this.selectedRect.y
          //  使圆圈允许拖拽
          this.isDragging = true
        }
      }

      // if (
      //   clickX >= this.widthend - 20 &&
      //   clickX <= this.widthend + 20 &&
      //   clickY >= this.heightend - 20 &&
      //   clickY >= this.heightend + 20
      // ) {
      //   this.selectedRect = rect
      // }
    },
    /**
     * 拖拽投影仪
     */
    onCanvasMouseMove (e) {
      let cvXreal
      let cvYreal
      let hLens
      let vLens
      if (this.isMouseInCanvas === false) {
        return
      }
      // 判断矩形是否开始拖拽
      if (this.isDragging === true) {
        // 判断拖拽对象是否存在
        if (this.selectedRect != null) {
          // 取得鼠标位置
          var touch = e.targetTouches[0]
          var x = touch.offsetX || (touch.clientX - touch.target.getBoundingClientRect().left)
          var y = touch.offsetY || (touch.clientY - touch.target.getBoundingClientRect().top)
          if (this.id === 'frontView') {
            if (this.projectorChecked) {
              // 将圆圈移动到鼠标位置
              if (x - this.x1 - this.cvX <= this.roomRectOnCanvas.x - this.pjRectOnCanvas.width / 2 + this.realToCanvas(this.limitData)) {
                x = this.roomRectOnCanvas.x + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2 + this.realToCanvas(this.limitData)
              }
              if (y - this.y1 - this.cvY <= this.roomRectOnCanvas.y - this.pjRectOnCanvas.height / 2 + this.realToCanvas(this.limitData)) {
                y = this.roomRectOnCanvas.y + this.y1 + this.cvY - this.pjRectOnCanvas.height / 2 + this.realToCanvas(this.limitData)
              }
              if (x - this.x1 - this.cvX >= this.roomRectOnCanvas.x + this.roomRectOnCanvas.width - this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.limitData)) {
                x = this.roomRectOnCanvas.x + this.roomRectOnCanvas.width + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.limitData)
              }
              if (y - this.y1 - this.cvY >= this.roomRectOnCanvas.y + this.roomRectOnCanvas.height - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.limitData)) {
                y = this.roomRectOnCanvas.y + this.roomRectOnCanvas.height + this.y1 + this.cvY - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.limitData)
              }
              if (!this.screenSizeChecked && this.throwDistanceChecked) {
                cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2)
                cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.pjRectOnCanvas.height / 2)
                this.SET_HLENSSHIFT((this.flToL + this.initScreenSize.w / 2 - cvXreal) / this.initScreenSize.w * 100.0)
                this.SET_VLENSSHIFT((this.flToB + this.initScreenSize.h / 2 - (this.houseInfo.roomH - cvYreal)) / this.initScreenSize.h * 100.0)
              } else {
                // 选中两个按钮时
                cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2)
                cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.pjRectOnCanvas.height / 2)
                if (this.throwDistanceChecked && this.screenSizeChecked) {
                  if (cvYreal < this.$commonViewJs.getKz()) {
                    cvYreal = this.$commonViewJs.getKz()
                  }
                  if (cvYreal > this.$commonViewJs.getLz()) {
                    cvYreal = this.$commonViewJs.getLz()
                  }
                  if (cvXreal > this.$commonViewJs.getPx()) {
                    cvXreal = this.$commonViewJs.getPx()
                  }
                  if (cvXreal < this.$commonViewJs.getQx()) {
                    cvXreal = this.$commonViewJs.getQx()
                  }
                  hLens = Number(((this.flToL + this.initScreenSize.w / 2) - cvXreal) / this.initScreenSize.w * 100)
                  vLens = Number((cvYreal - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h * 100)
                  this.SET_HLENSSHIFT((hLens))
                  this.SET_VLENSSHIFT((vLens))
                }
                if (this.floor_footProjector_checked) {
                  cvYreal = this.graph.pjZ
                }
                this.PJX(cvXreal)
                this.PJZ(cvYreal)
              }
            } else if (this.screenMoveChecked) {
              // 拖动屏幕
              hLens = -Number((this.graph.pjX - this.canvasToReal(x - this.x1 - this.cvX + this.selectedRect.width / 2)) / this.initScreenSize.w)
              vLens = Number((this.graph.pjZ - this.canvasToReal(y - this.y1 - this.cvY + this.selectedRect.height / 2)) / this.initScreenSize.h)
              if (hLens < this.graph.hLensShift.min) {
                hLens = this.graph.hLensShift.min
              }
              if (hLens > this.graph.hLensShift.max) {
                hLens = this.graph.hLensShift.max
              }
              if (vLens < this.graph.vLensShift.min) {
                vLens = this.graph.vLensShift.min
              }
              if (vLens > this.graph.vLensShift.max) {
                vLens = this.graph.vLensShift.max
              }
              this.SET_HLENSSHIFT(hLens * 100)
              this.SET_VLENSSHIFT(vLens * 100)
            }
          } else {
            var minMaxD = this.$commonViewJs.getMinDisByLens()
            var minD = this.isOutOfSpec ? this.realToCanvas(this.offset + this.limitData) : this.realToCanvas(minMaxD.minDis)
            var maxD = this.isOutOfSpec ? Number.POSITIVE_INFINITY : this.realToCanvas(minMaxD.maxDis)

            if (!this.isOutOfSpec && !this.realThrowDistanceChecked) {
              if (!this.screenSizeChecked) {
                if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 >= maxD) {
                  x = maxD + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
                }
              }
              if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 > this.roomRectOnCanvas.x + this.roomRectOnCanvas.width) {
                x = this.roomRectOnCanvas.x + this.roomRectOnCanvas.width + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
              }
              if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 >= this.realToCanvas(this.$commonViewJs.getMaxDisByRoom())) {
                x = this.realToCanvas(this.$commonViewJs.getMaxDisByRoom()) + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
              }
            }

            if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 <= minD && !this.realThrowDistanceChecked) {
              x = minD + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
            }
            if (y - this.y1 - this.cvY < this.roomRectOnCanvas.y - this.pjRectOnCanvas.height / 2 + this.realToCanvas(this.limitData)) {
              y = this.roomRectOnCanvas.y + this.y1 + this.cvY - this.pjRectOnCanvas.height / 2 + this.realToCanvas(this.limitData)
            }

            if (y - this.y1 - this.cvY > this.roomRectOnCanvas.y + this.roomRectOnCanvas.height - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.limitData)) {
              y = this.roomRectOnCanvas.y + this.roomRectOnCanvas.height - this.pjRectOnCanvas.height / 2 + this.y1 + this.cvY - this.realToCanvas(this.limitData)
            }
            var screen = {}
            // screen.calX = this.initScreenSize.w
            // screen.calY = this.initScreenSize.h

            cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.offset))
            screen = this.$commonViewJs.getInitScreenXyFromDist(cvXreal)
            if (this.isOutOfSpec && (cvXreal + this.offset) > this.houseInfo.roomD) {
              this.SET_GRAPH_ROOMD((cvXreal + this.offset))
            }
            if (!this.realThrowDistanceChecked) {
              if (this.screenSizeChecked) {
                if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 < this.realToCanvas(this.$commonViewJs.getKy())) {
                  x = this.realToCanvas(this.$commonViewJs.getKy()) + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
                }
                if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 > this.realToCanvas(this.$commonViewJs.getLy())) {
                  x = this.realToCanvas(this.$commonViewJs.getLy()) + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
                }
                cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.offset))
                this.PJY(cvXreal)
                // 计算当当前投影仪不为超短焦，并且为电子变焦时
                this.checkIsElectron()
              } else {
                this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(cvXreal))
                this.PJY(cvXreal)
                let screenNow = this.$commonViewJs.getScreenXyFromDist(cvXreal)
                this.SCRNW(screenNow.calX)
                this.SCRNH(screenNow.calY)
              }
            }
            cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.pjRectOnCanvas.height / 2)
            if (this.id === 'sideView') {
              if (this.throwDistanceChecked && this.screenSizeChecked) {
                vLens = (cvYreal - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h
                // 选中两个按钮时
                if (vLens < this.graph.vLensShift.min) {
                  vLens = this.graph.vLensShift.min
                  cvYreal = this.graph.vLensShift.min * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                if (vLens > this.graph.vLensShift.max) {
                  vLens = this.graph.vLensShift.max
                  cvYreal = this.graph.vLensShift.max * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                this.PJZ(cvYreal)
                this.SET_VLENSSHIFT(vLens * 100)
              } else if (this.throwDistanceChecked && !this.screenSizeChecked && !this.realThrowDistanceChecked) {
                // 仅选中Screen Position的checkbox时
                vLens = (cvYreal - (this.houseInfo.roomH - (this.flToB + screen.calY / 2))) / screen.calY
                if (vLens < this.graph.vLensShift.min) {
                  vLens = this.graph.vLensShift.min
                  cvYreal = this.graph.vLensShift.min * screen.calY + (this.houseInfo.roomH - (this.flToB + screen.calY / 2))
                }
                if (vLens > this.graph.vLensShift.max) {
                  vLens = this.graph.vLensShift.max
                  cvYreal = this.graph.vLensShift.max * screen.calY + (this.houseInfo.roomH - (this.flToB + screen.calY / 2))
                }
                this.PJZ(cvYreal)
                this.PJX(this.flToL + screen.calX / 2 - screen.calX * this.hLensShiftNow / 100)
                this.SET_VLENSSHIFT(vLens * 100)
              } else if (this.throwDistanceChecked && this.realThrowDistanceChecked) {
                // 仅选中Screen Position的checkbox时
                vLens = (cvYreal - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h
                if (vLens < this.graph.vLensShift.min) {
                  vLens = this.graph.vLensShift.min
                  cvYreal = this.graph.vLensShift.min * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                if (vLens > this.graph.vLensShift.max) {
                  vLens = this.graph.vLensShift.max
                  cvYreal = this.graph.vLensShift.max * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                this.PJZ(cvYreal)
                this.SET_VLENSSHIFT(vLens * 100)
              } else {
                if (this.floor_footProjector_checked) {
                  cvYreal = this.graph.pjZ
                }
                this.PJZ(cvYreal)
              }
            } else if (this.id === 'topView') {
              if (this.throwDistanceChecked && this.screenSizeChecked) {
                hLens = ((this.flToL + this.initScreenSize.w / 2) - (this.houseInfo.roomW - cvYreal)) / this.initScreenSize.w
                if (hLens < this.graph.hLensShift.min) {
                  hLens = this.graph.hLensShift.min
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.min * this.initScreenSize.w)
                }
                if (hLens > this.graph.hLensShift.max) {
                  hLens = this.graph.hLensShift.max
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.max * this.initScreenSize.w)
                }
                this.SET_HLENSSHIFT(hLens * 100)
                this.PJX(this.houseInfo.roomW - cvYreal)
              } else if (!this.screenSizeChecked && this.throwDistanceChecked && !this.realThrowDistanceChecked) {
                this.PJZ(this.houseInfo.roomH - (this.flToB + screen.calY / 2 - screen.calY * this.vLensShiftNow / 100))
                hLens = ((this.flToL + screen.calX / 2) - (this.houseInfo.roomW - cvYreal)) / screen.calX * 100
                this.SET_HLENSSHIFT(hLens)
                this.PJX(this.houseInfo.roomW - cvYreal)
              } else if (this.throwDistanceChecked && this.realThrowDistanceChecked) {
                hLens = ((this.flToL + this.initScreenSize.w / 2) - (this.houseInfo.roomW - cvYreal)) / this.initScreenSize.w * 100
                this.SET_HLENSSHIFT(hLens)
                this.PJX(this.houseInfo.roomW - cvYreal)
              } else {
                this.PJX(this.houseInfo.roomW - cvYreal)
              }
            }
          }
        }
      }
    },

    checkIsElectron () {
      let flag = 1
      if (this.position === 1) {
        flag = -1
      }
      // 计算当当前投影仪不为超短焦，并且为电子变焦时
      if (this.screenSizeChecked && this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) {
        let wSize = this.$commonViewJs.getScreenSizeFromDist(this.graph.pjY)
        let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData)
        let l = (wSize.calY - this.graph.scrnH) / 2
        let v2 = defaultDistInfo.wv.wv2 * wSizeInch
        let v2l = v2 - l
        let vlensShiftN = (v2l - this.graph.scrnH / 2) / this.initScreenSize.h * flag
        this.SET_VLENSSHIFT(vlensShiftN)
        let vals = {}
        vals.max = vlensShiftN
        vals.min = vlensShiftN
        this.VLENSSHIFT(vals)
        let ll = {}
        ll.max = vlensShiftN * flag
        ll.min = vlensShiftN * flag
        this.SET_TEMVLENSSHIFT(ll)
      }
    },
    onCanvasMouseOut (e) {
      this.isMouseInCanvas = false
    },
    /**
     * 鼠标松开
     */
    onCanvasMouseUp () {
      this.isDragging = false
      this.isMouseInCanvas = false
    },
    onHouseInfoChanged () {
      this.context.translate(-this.cvX, -this.cvY)
      this.getProportion()
      this.initCanvasXY()
      this.drawCv()
    },
    onGraphChanged () {
      this.drawCv()
    },
    initPjImg () {
      this.pjImg.onload = function () {
        this.drawPj()
        this.drawDashLines()
      }.bind(this)
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, this.selectedLensData)
    },
    drawPjImg () {
      this.context.drawImage(
        this.pjImg,
        this.pjRectOnCanvas.x,
        this.pjRectOnCanvas.y,
        this.pjRectOnCanvas.width,
        this.pjRectOnCanvas.height
      )
    },
    drawPjImgRotate (x, y, angle) {
      this.context.save()
      this.context.translate(x, y)
      this.context.rotate(angle * Math.PI / 180)
      this.context.translate(-x, -y)
      this.drawPjImg()
      this.context.restore()
    },
    drawPj () {
      let x, y
      if (this.id === 'sideView') {
        if (this.$commonViewJs.isVAngle()) {
          x = this.realToCanvas(this.graph.pjY + this.offset)
          y = this.realToCanvas(this.graph.pjZ)

          this.drawPjImgRotate(x, y, this.vAngle)
          return
        }
      } else if (this.id === 'topView') {
        if (this.$commonViewJs.isHAngle()) {
          x = this.realToCanvas(this.graph.pjY + this.offset)
          y = this.realToCanvas(this.houseInfo.roomW - this.graph.pjX)

          this.drawPjImgRotate(x, y, this.hAngle)
          return
        }
      }
      this.drawPjImg()
    },
    drawRoomRect () {
      this.$draw.drawRect(
        this.context,
        this.roomRectOnCanvas.x,
        this.roomRectOnCanvas.y,
        this.roomRectOnCanvas.width,
        this.roomRectOnCanvas.height,
        this.$constant.roomLineColor,
        this.$constant.roomFillColor,
        2,
        true
      )
    },
    drawAvlRect () {
      if (this.$commonViewJs.isAvlExist() || this.avlRect) {
        if (this.id === 'frontView') {
          this.$draw.drawPath(
            this.context,
            this.avlRectOnCanvas,
            this.$constant.avlRangeColor
          )
        } else {
          this.$draw.drawRect(
            this.context,
            this.avlRectOnCanvas.x,
            this.avlRectOnCanvas.y,
            this.avlRectOnCanvas.width,
            this.avlRectOnCanvas.height,
            this.$constant.avlRangeColor,
            this.$constant.avlRangeColor,
            2,
            true
          )
        }
      }
    },
    drawDashLines () {
      for (var i = 0; i < this.arrDashLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrDashLinesOnCanvas[i],
          this.$constant.dashLineColor,
          this.arrDashLinesOnCanvas[i].lineWidth,
          [2, 2]
        )
      }
    },
    drawDashRemainLines () {
      for (var i = 0; i < this.arrDashRemainLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrDashRemainLinesOnCanvas[i],
          this.$constant.dashRemainLineColor,
          this.arrDashRemainLinesOnCanvas[i].lineWidth,
          [2, 2]
        )
      }
    },
    drawOffsetLines () {
      if (this.id !== 'frontView') {
        for (var i = 0; i < this.arrOffsetLinesOnCanvas.length; i++) {
          this.$draw.drawLine(
            this.context,
            this.arrOffsetLinesOnCanvas[i],
            this.$constant.dashLineColor,
            this.arrOffsetLinesOnCanvas[i].lineWidth,
            [2, 2]
          )
        }
      }
    },
    drawRectLines () {
      var i, color, lineWidth
      if (this.id !== 'frontView') {
        for (i = 0; i < this.arrRectLinesOnCanvas.length; i++) {
          color = this.arrRectLinesOnCanvas[i].color
          lineWidth = this.arrRectLinesOnCanvas[i].lineWidth
          this.$draw.drawLine(
            this.context,
            this.arrRectLinesOnCanvas[i],
            color,
            lineWidth
          )
        }
        let reColor = this.$constant.rectLineColor
        if (this.id === 'sideView') {
          for (let i = 1; i < this.drawData.length; i++) {
            for (let j = 0; j < this.drawData[i].length; j++) {
              if (this.drawData[i][j].x < this.limitData || Math.abs(this.drawData[i][j].x - this.houseInfo.roomW) < this.limitData) {
                reColor = this.$constant.rectFillColor
              }
            }
          }
        }
        if (this.id === 'topView') {
          for (let i = 1; i < this.drawData.length; i++) {
            for (let j = 0; j < this.drawData[i].length; j++) {
              if (this.drawData[i][j].z < this.limitData || Math.abs(this.drawData[i][j].z - this.houseInfo.roomH) < this.limitData) {
                reColor = this.$constant.rectFillColor
              }
            }
          }
        }
        lineWidth = 3
        this.$draw.drawLines(
          this.context,
          this.arrCatchAreaOnCanvas,
          reColor,
          lineWidth
        )
      } else {
      // 设置边框色，因为frontView无边框色，
        this.$draw.drawLines(
          this.context,
          this.arrCatchAreaOnCanvas,
          this.$constant.catchAreaColor,
          lineWidth
        )
      }
    },
    drawLightingArea () {
      if (this.id !== 'frontView') {
        for (let i = 0; i < this.arrLightingAreaOnCanvas.length; i++) {
          this.$draw.drawPath(
            this.context,
            this.arrLightingAreaOnCanvas[i],
            this.$constant.catchAreaColor
          )
        }
      }
    },
    drawCatchArea () {
      if (this.id === 'frontView') {
        this.$draw.drawPath(
          this.context,
          this.arrCatchAreaOnCanvas,
          this.$constant.catchAreaColor
        )
      } else {
        this.$draw.drawPath(
          this.context,
          this.arrCatchAreaOnCanvas,
          this.$constant.catchFillColor
        )
      }
    },
    drawBlackArea () {
      if (this.arrBlackArea) {
        this.$draw.drawPath(
          this.context,
          this.arrBlackAreaOnCanvas,
          this.$constant.blackAreaColor
        )
      }
    },
    drawHelpLines () {
      for (var i = 0; i < this.arrHelpLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrHelpLinesOnCanvas[i],
          this.$constant.helpLineColor,
          0.8
        )
      }
    },
    drawHelpText () {
      for (var i = 0; i < this.arrHelpTextOnCanvas.length; i++) {
        this.$draw.drawText(
          this.context,
          this.arrHelpTextOnCanvas[i].text,
          this.arrHelpTextOnCanvas[i].x,
          this.arrHelpTextOnCanvas[i].y,
          this.$constant.helpTextColor
        )
      }
    },
    drawArrowRects () {
      if (this.id === 'frontView') {
        for (var i = 0; i < this.arrowRectsOnCanvas.length; i++) {
          var ps = []
          var p1 = {}
          var p2 = {}
          var p3 = {}
          p1.x = this.arrowRectsOnCanvas[i].x1
          p1.y = this.arrowRectsOnCanvas[i].y1
          ps.push(p1)
          p2.x = this.arrowRectsOnCanvas[i].x2
          p2.y = this.arrowRectsOnCanvas[i].y2
          ps.push(p2)
          p3.x = this.arrowRectsOnCanvas[i].x3
          p3.y = this.arrowRectsOnCanvas[i].y3
          ps.push(p3)
          this.$draw.drawPath(
            this.context,
            ps,
            this.$constant.avlRangeColor
          )
        }
        let downDest = 0
        for (let i = 0; i < this.arrHelpLinesOnCanvas.length; i++) {
          if (this.arrHelpLinesOnCanvas[i].y1 > downDest) {
            downDest = this.arrHelpLinesOnCanvas[i].y1
          }
        }
        var leftmove = ((this.houseInfo.roomW + this.graph.pjX) / 2 + this.graph.pjX / 2) / 2
        let centerPosition = {
          x: this.realToCanvas(leftmove) + this.cvX,
          y: downDest + this.cvY
        }
        this.$emit('removeCenter', centerPosition)
      }
    },
    drawRectHorSecLinesOnCanvas () {
      if (this.arrRectHorSecLinesOnCanvas === null || this.arrRectHorSecLinesOnCanvas === undefined) {
        return
      }

      var i, color, lineWidth
      for (i = 0; i < this.arrRectHorSecLinesOnCanvas.length; i++) {
        color = this.arrRectHorSecLinesOnCanvas[i].color
        lineWidth = this.arrRectHorSecLinesOnCanvas[i].lineWidth
        this.$draw.drawLine(
          this.context,
          this.arrRectHorSecLinesOnCanvas[i],
          color,
          lineWidth
        )
      }
    },
    r2c (r) {
      let x = r.x ? this.realToCanvas(r.x) : 0
      let y = r.y ? this.realToCanvas(r.y) : 0
      let w = r.width ? this.realToCanvas(r.width) : 0
      let h = r.height ? this.realToCanvas(r.height) : 0

      return this.$draw.toRect(x, y, w, h)
    },
    l2c (l) {
      if (l === null || l === undefined) {
        return
      }
      let tmp = []
      let x1, y1, x2, y2
      for (let i = 0; i < l.length; i++) {
        x1 = l[i].x1 ? this.realToCanvas(l[i].x1) : 0
        y1 = l[i].y1 ? this.realToCanvas(l[i].y1) : 0
        x2 = l[i].x2 ? this.realToCanvas(l[i].x2) : 0
        y2 = l[i].y2 ? this.realToCanvas(l[i].y2) : 0
        tmp.push(this.$draw.toLine(x1, y1, x2, y2, l[i].color, l[i].lineWidth))
      }
      return tmp
    },
    arp2c (l) {
      if (l === null || l === undefined) {
        return
      }
      let tmp = []
      let x1, y1, x2, y2, x3, y3
      for (let i = 0; i < l.length; i++) {
        x1 = l[i].x1 ? this.realToCanvas(l[i].x1) : 0
        y1 = l[i].y1 ? this.realToCanvas(l[i].y1) : 0
        x2 = l[i].x2 ? this.realToCanvas(l[i].x2) : 0
        y2 = l[i].y2 ? this.realToCanvas(l[i].y2) : 0
        x3 = l[i].x3 ? this.realToCanvas(l[i].x3) : 0
        y3 = l[i].y3 ? this.realToCanvas(l[i].y3) : 0
        tmp.push(this.$draw.toArrow(x1, y1, x2, y2, x3, y3, l[i].color))
      }
      return tmp
    },
    ap2c (p) {
      if (p === null || p === undefined) {
        return
      }
      let tmp = []
      let x, y
      for (let i = 0; i < p.length; i++) {
        let ps = []
        for (let j = 0; j < p[i].length; j++) {
          x = p[i][j].x ? this.realToCanvas(p[i][j].x) : 0
          y = p[i][j].y ? this.realToCanvas(p[i][j].y) : 0
          ps.push(this.$draw.toPoint(x, y))
        }
        tmp.push(ps)
      }
      return tmp
    },
    p2c (p) {
      if (p === null || p === undefined) {
        return
      }
      let tmp = []
      let x, y
      for (let i = 0; i < p.length; i++) {
        x = p[i].x ? this.realToCanvas(p[i].x) : 0
        y = p[i].y ? this.realToCanvas(p[i].y) : 0
        tmp.push(this.$draw.toPoint(x, y))
      }

      return tmp
    },
    t2c (t) {
      let tmp = []
      let x, y
      for (let i = 0; i < t.length; i++) {
        x = t[i].x ? this.realToCanvas(t[i].x) : 0
        y = t[i].y ? this.realToCanvas(t[i].y) : 0
        tmp.push(this.$draw.toText(x, y, t[i].text))
      }

      return tmp
    },
    canvasToReal (data) {
      return data * this.proportion
    },
    realToCanvas (data) {
      return data / this.proportion
    },
    resizeDraw () {
      this.refreshCv()
      this.refreshData()
      this.drawCv()
    },
    refreshData () {
      this.pjRectToCanvas()
      this.roomRectToCanvas()
      this.avlRectToCanvas()
      this.arrRectLinesToCanvas()
      this.arrLightingAreaToCanvas()
      this.arrCatchAreaToCanvas()
      this.arrBlackAreaToCanvas()
      this.arrDashLinesToCanvas()
      this.arrDashRemainLinesToCanvas()
      this.arrOffsetLinesToCanvas()
      this.arrHelpLinesToCanvas()
      this.arrHelpTextToCanvas()
      this.arrRectHorSecLinesToCanvas()
      this.arrowRectsToCanvas()
    },
    pjRectToCanvas () {
      let x = this.realToCanvas(this.pjRect.x) - this.pjRect.width / 2
      let y = this.realToCanvas(this.pjRect.y) - this.pjRect.height / 2
      return this.$draw.toRect(x, y, this.pjRect.width, this.pjRect.height)
    },
    roomRectToCanvas () {
      return this.r2c(this.roomRect)
    },
    avlRectToCanvas () {
      if (this.$commonViewJs.isAvlExist() || this.avlRect) {
        if (this.id === 'frontView') {
          return this.p2c(this.avlRect)
        } else {
          return this.r2c(this.avlRect)
        }
      }
    },
    arrRectLinesToCanvas () {
      return this.l2c(this.arrRectLines)
    },
    arrLightingAreaToCanvas () {
      return this.ap2c(this.arrLightingArea)
    },
    arrCatchAreaToCanvas () {
      return this.p2c(this.arrCatchArea)
    },
    arrBlackAreaToCanvas () {
      if (this.arrBlackArea) {
        return this.p2c(this.arrBlackArea)
      }
    },
    arrDashLinesToCanvas () {
      return this.l2c(this.arrDashLines)
    },
    arrDashRemainLinesToCanvas () {
      return this.l2c(this.arrDashRemainLines)
    },
    arrOffsetLinesToCanvas () {
      return this.l2c(this.arrOffsetLines)
    },
    arrHelpLinesToCanvas () {
      return this.l2c(this.arrHelpLines)
    },
    arrHelpTextToCanvas () {
      return this.t2c(this.arrHelpText)
    },
    arrRectHorSecLinesToCanvas () {
      return this.l2c(this.arrRectHorSecLines)
    },
    arrowRectsToCanvas () {
      return this.arp2c(this.arrowRects)
    }
  }
}
</script>

<style scoped>
</style>
